"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobModelSchema = void 0;
const zod_1 = require("zod");
exports.JobModelSchema = zod_1.z.object({
    userId: zod_1.z.string(),
    jobId: zod_1.z.string(),
    details: zod_1.z.object({}),
    retryCount: zod_1.z.number(),
    queueName: zod_1.z.string(),
    agliveNo: zod_1.z.string(),
    transactionDetail: zod_1.z.string(),
    signedTransactions: zod_1.z.string(),
    hash: zod_1.z.object({})
});
